import * as angular from 'angular';
import * as _ from 'lodash';
import { IDebugHelper } from 'v2/modules/core/debug-helper';
import { IV3ModelHelper } from 'v2/modules/core/v3-model-helper';

type itemWithDistractors = {
  item_id: number;
  association_id: number;
  association_text: string;
  anchor_id: string;
  anchor_text: string;
  distractors: v3.resource.IDistractor[];
};

interface ICtrlScope extends ng.IScope {
  user: v3.resource.IUser;
  partner: v3.resource.IPartner;
  set: v3.resource.ISet;
  itemsWithDistractors: itemWithDistractors[];
  removeDistractor: (distractor: v3.resource.IDistractor, item: itemWithDistractors) => void;
  addDistractor: (item: itemWithDistractors) => void;
  updateDistractor: (distractor: v3.resource.IDistractor) => void;
}

angular.module('cerego.moduleView').controller('editDistractorsCtrl', [
  '$scope',
  '$window',
  '$routeParams',
  'DebugHelper',
  'V3ModelHelper',
  'myPartnersService',
  'moduleContextService',
  'SiteNavigationService',
  'V3SetItemsResource',
  'V3ConceptDistractorsResource',
  (
    $scope: ICtrlScope,
    $window: ng.IWindowService,
    $routeParams: ng.route.IRouteParamsService,
    DebugHelper: IDebugHelper,
    V3ModelHelper,
    myPartnersService,
    moduleContextService,
    SiteNavigationService,
    V3SetItemsResource,
    V3ConceptDistractorsResource
  ) => {
    DebugHelper.register('editDistractorsCtrl', $scope);

    $scope.itemsWithDistractors = [];

    // TODO don't delete if it would mean less than 4 left?
    // Note this may not handle transliterations correctly
    $scope.removeDistractor = (distractor, item) => {
      V3ConceptDistractorsResource.delete(
        {
          id: distractor.id
        },
        success => {
          _.pull(item.distractors, distractor);
        },
        error => {
          DebugHelper.logError(error, 'V3ConceptsResource Delete Error, id: ' + distractor.id);
        }
      );
    };

    $scope.updateDistractor = distractor => {
      V3ConceptDistractorsResource.update(
        {
          id: distractor.id,
          data: distractor
        },
        success => {
          // noop
        },
        error => {
          DebugHelper.logError(error, 'V3ConceptsResource Delete Error, id: ' + distractor.id);
        }
      );
    };

    $scope.addDistractor = item => {
      V3ConceptDistractorsResource.create(
        {
          concept_id: item.anchor_id
        },
        success => {
          item.distractors.push(V3ModelHelper.parse(success));
        },
        error => {
          DebugHelper.logError(error, 'Error when trying to creator distractor on concept id: ' + item.anchor_id);
        }
      );
    };

    myPartnersService.initialize().then(partner => {
      $scope.partner = partner;
    });

    moduleContextService.fetchModule($routeParams.set_id, 'set').then(module => {
      $scope.set = module;
    });

    // Get items for set, filter out only vocab items, grab distractors, and add to itemsWithDistractors
    V3SetItemsResource.query({
      set_id: $routeParams.set_id,
      include: 'facets.anchor,facets.association',
      'filter[type][]': ['Vocabulary'],
      'page[size]': 200
    }).$promise.then(success => {
      const items = V3ModelHelper.parse(success).filter(item => item.attributes['template-type'] === 'vocabulary');
      items.forEach(item => {
        const AnchorConcept = item.relationships.facets.data[0].relationships.anchor.data;
        const associationConcept = item.relationships.facets.data[0].relationships.association.data;
        // tslint:disable-next-line:no-shadowed-variable
        const itemWithDistractors = {
          item_id: item.id,
          anchor_id: AnchorConcept.id,
          anchor_text: AnchorConcept.attributes.text,
          association_id: associationConcept.id,
          association_text: associationConcept.attributes.text,
          distractors: []
        };
        V3ConceptDistractorsResource.query({ concept_id: AnchorConcept.id, include_unstudiable: true }).$promise.then(
          // tslint:disable-next-line:no-shadowed-variable
          success => {
            itemWithDistractors.distractors = V3ModelHelper.parse(success);
            $scope.itemsWithDistractors.push(itemWithDistractors);
          }
        );
      });
      SiteNavigationService.setContext($scope.set, 'set');
    });
  }
]);
